import exp from 'constants';
import { API } from './index';
import Cookies from 'js-cookie';

export const getPreview = async (socialID: string) => {
  try {
    const response = await API.get('/api/v1/dm/preview', {
      params: {
        socialID,
      },
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// export const getConversation = async (convoID: string) => {
//   const authToken = Cookies.get("accessToken");
//   try {
//     const response = await API.get("/api/v1/dm/conversation", {
//       params: {
//         convoID,
//       },
//       headers: {
//         Authorization: `Bearer ${authToken}`,
//       },
//     });

//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// };

export const getConversations = async (
  socialId: number,
  page: number,
  pageSize: number = 10,
  sortDirection: string,
  status?: string
) => {
  try {
    console.log('GETTING CONVERSATIONS');
    const params: any = {
      socialId,
      page,
      pageSize,
      sortDirection,
    };

    // Only add status to params if it's not "all"
    if (status && status !== 'all') {
      params.status = status;
    }

    const response = await API.get('/api/v1/dm/conversations', {
      params,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// respond to conversation
export const respondToConversation = async (
  convoID: number,
  socialPlatformID: string,
  message: string
) => {
  try {
    const response = await API.post(`/api/v1/dm/dmresponse`, {
      convoID,
      socialPlatformID,
      message,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error; // re-throwing so the caller can handle it if needed
  }
};

export const putUpdatePinned = async (convoID: number, pinned: boolean) => {
  try {
    const response = await API.put(`/api/v1/dm/update-dmpinned`, {
      convoID,
      pinned,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const putUpdateStatus = async (convoID: number, status: string) => {
  try {
    const response = await API.put(`/api/v1/dm/update-dmstatus`, {
      convoID,
      status,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const regenerateDMResponse = async (
  message: unknown,
  extras: string
) => {
  try {
    const response = await API.post(`/api/v1/dm/generate-dm`, {
      message,
      extras,
      regenerate: true,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
